// #region imports

// --- Angular
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

// --- HS Code
import { SurveySummaryBasicModel } from '../../../models';
import { GoogleAnalyticsService } from '../../../core/services';
import { SurveySummariesBottomSheetOutput } from './survey-summary-bottom-sheet.model';

// #endregion

@Component({
  selector: 'hs-survey-summary-bottom-sheet',
  templateUrl: './survey-summary-bottom-sheet.component.html',
  styleUrls: ['./survey-summary-bottom-sheet.component.scss'],
})
export class SurveySummaryBottomSheetComponent {

  showRegisterButton = false;

  get surveySummaries() {
    if (!Array.isArray(this.data.surveySummaries)) {
      return [];
    }
    return [...this.data.surveySummaries];
  }

  get selectedSurvey() {
    return this.data.selectedSurvey;
  }

  get hasIncompleteSurveys() {
    return this.data.hasIncompleteSurveys;
  }

  constructor(
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _bottomSheetRef: MatBottomSheetRef<SurveySummaryBottomSheetComponent, SurveySummariesBottomSheetOutput>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    private data: SurveySummaryBasicModel,
  ) {
    this.showRegisterButton = data.shouldShowSelfRegistration ?? false;
  }

  onSurveyClick(surveyId: string) {
    this._googleAnalyticsService.eventEmitter(
      'selected_survey',
      'dashboard',
      'selected_survey_changed',
      `Selected Survey Changed = ${surveyId}`
    );
    this._bottomSheetRef.dismiss({type: 'selected', surveyId});
  }

  registerButtonClicked() {
    this._bottomSheetRef.dismiss({type: 'register'});
  }
  closeIconClick() {
    this._bottomSheetRef.dismiss({type: 'close'});
  }
}
